import React from "react";
import HomePage from "./pages/HomePage";

const App = () => {
  return <HomePage />;
};

export default App;



